import { ArrowUpDown, ChevronDown, ChevronUp } from "lucide-react";

import LinhaItemEstoque from "./LinhaItemEstoque";

const COLUNAS = [
  { rotulo: "Código" },
  { rotulo: "Item", campo: "name" },
  { rotulo: "Estoque", campo: "stock_quantity" },
  { rotulo: "Mín – Máx", campo: "stock_min" },
  { rotulo: "Custo da ficha", campo: "average_price", dica: "Custo de 1 unidade da ficha, já com a perda. Preço médio = média das últimas 5 compras." },
  { rotulo: "", cls: "text-right" },
];

/** Tabela de estoque em linhas de duas alturas (principal + detalhe), com a
 *  barra min→max no saldo. Ordena pelo cabecalho como antes. */
export default function TabelaItensEstoque({
  itens, totalCadastrados, totalFiltrados, getStatus, ehReceita, canEdit,
  sortField, sortDirection, onSort, onHistorico, onMovimentar, onEditar, onExcluir, onReativar, arquivados = false,
}) {
  return (
    <div data-e2e="tabela-estoque">
      <div className="px-4 py-2 text-xs text-muted-foreground border-b bg-muted/20">Mostrando {itens.length} de {totalFiltrados} itens</div>
      <div className="overflow-x-auto">
        <table className="w-full" data-testid="ingredients-table">
          <thead className="bg-muted/50 border-b">
            <tr>
              {COLUNAS.map((c) => (
                <th key={c.rotulo || "acoes"} data-e2e={c.campo ? `th-${c.campo}` : undefined} title={c.dica || (c.campo ? "Clique para ordenar" : undefined)}
                  onClick={c.campo ? () => onSort(c.campo) : undefined}
                  className={`text-left py-3 px-4 text-[11px] font-semibold text-muted-foreground uppercase tracking-wider ${c.cls || ""} ${c.campo ? "cursor-pointer hover:bg-muted/80 select-none" : ""}`}>
                  <span className="inline-flex items-center gap-1">
                    {c.rotulo}
                    {c.campo && (sortField === c.campo
                      ? (sortDirection === "asc" ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />)
                      : <ArrowUpDown className="w-3 h-3 opacity-50" />)}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {itens.length === 0 ? (
              <tr><td colSpan={COLUNAS.length} className="text-center py-12 text-muted-foreground">
                {arquivados ? "Nenhum item arquivado." : totalCadastrados === 0 ? 'Nenhum item cadastrado. Clique em "Novo Item" para começar.' : "Nenhum item encontrado com os filtros aplicados."}
              </td></tr>
            ) : itens.map((item, idx) => (
              <LinhaItemEstoque key={item.id} item={item} status={getStatus(item)} ehReceita={ehReceita(item)} canEdit={canEdit} zebra={idx % 2 === 1} arquivado={arquivados}
                onHistorico={() => onHistorico(item)} onMovimentar={() => onMovimentar(item)} onEditar={() => onEditar(item)} onExcluir={() => onExcluir(item)} onReativar={() => onReativar && onReativar(item)} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
